import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { View } from "@/components";
import * as React from "react";
import styled from "styled-components";
import { ProtectCenterPage } from "@/modules/landings/protection/ProtectCenterPage";
const ProtectionReportPageWrapper = styled(View).withConfig({
    componentId: "sc-fbd9634a-0"
})(_templateObject());
const ProtectionrNumber = ()=>{
    return /*#__PURE__*/ _jsx(ProtectionReportPageWrapper, {
        children: /*#__PURE__*/ _jsx(ProtectCenterPage, {})
    });
};
export default ProtectionrNumber;
